
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 7A6 6 0 111 7a6 6 0 0112 0z","stroke":"#A3A3A3","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.818 8.673v-.826c0-.207.167-.374.374-.374.826 0 1.496-.67 1.496-1.496v-.104a1.6 1.6 0 00-1.6-1.6H7.05c-.903 0-1.636.733-1.636 1.636v.273m1.403 3.69v.137","stroke":"#A3A3A3","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    